import { jsx as r } from "react/jsx-runtime";
import { forwardRef as i } from "react";
const v = i(({
  stroke: a = "currentColor",
  strokeWidth: o = "2",
  strokeLinecap: n = "round",
  strokeLinejoin: e = "round",
  fill: d = "none",
  size: t = "24",
  viewBox: s = "0 0 30 30",
  style: f = {
    transform: "scale(1.5)"
  },
  ...h
}, m) => /* @__PURE__ */ r(
  "svg",
  {
    ref: m,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: s,
    fill: d,
    stroke: a,
    strokeWidth: o,
    strokeLinecap: n,
    strokeLinejoin: e,
    style: f,
    ...h,
    children: /* @__PURE__ */ r("g", { id: "off", transform: "translate(-5.031 -32)", children: /* @__PURE__ */ r("path", { id: "Path_17", "data-name": "Path 17", d: "M122.882-21.652a3.856,3.856,0,0,0,3.808,3.775v2.553a5.968,5.968,0,0,1-3.766-1.084v4.777c0,6.067-6.748,7.961-9.464,3.61-1.75-2.786-.686-7.7,4.914-7.906v2.69a8.982,8.982,0,0,0-1.3.316,2.168,2.168,0,0,0-1.75,2.553c.378,2.608,5.264,3.39,4.858-1.716v-9.567Z", transform: "translate(-99.658 60.651)" }) })
  }
));
export {
  v as default
};
